import { omitBy, isNil, find, map, forEach } from 'lodash';

const response = (data: any) => {

    let mappedObj = {

    }

    mappedObj[data.options.orgType] = data.options.options;

    const mapSubOptions = (optionList) => {
        let subOptions = []
    
        forEach(optionList, optionObj=>{
            subOptions.push(...optionObj?.subOptions?.options)
        })
        mappedObj[optionList[0].subOptions.orgType] = subOptions;

    }

    if(data.options.options && data.options.orgType != "CUSTOMER"){
        mapSubOptions(data.options.options)
    }

    return omitBy({
        ...mappedObj
    }, isNil) ;
}

export default response;